"use strict";
const angular = require("angular");

const uiRouter = require("angular-ui-router");

import routes from "./adDefaultStat.routes";

export class AdDefaultStatComponent {
  filters = {
    begin: new Date("2021-01-01"),
    end: new Date("2021-02-15"),
  };
  sort = {
    key: "views",
    value: "1",
  };
  array = [];

  /*@ngInject*/
  constructor($http, $location, $cookies) {
    this.message = "Hello";
    this.$location = $location;
    this.$cookies = $cookies;
    this.$http = $http;
  }

  $onInit() {
    this.filters.begin = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
    this.filters.end = new Date();
    this.search();
  }

  search() {
    if (this.$cookies.get("token")) {
      this.$http
        .get("/api/ad_defaults/stat", {
          header: {
            Accept: "application/json",
            "Content-Type": "application/json",
            token: this.$cookies.get("token"),
          },
          params: this.filters,
        })
        .then((response) => {
          if (response.data.data) {
            this.array = response.data.data;
            this.$sort();
          }
        });
    } else {
      this.$location.path("main");
    }
  }

  $sort() {
    this.array.sort((a, b) => {
      if (Number(this.sort.value) > 0) {
        return b[this.sort.key] - a[this.sort.key];
      }
      return a[this.sort.key] - b[this.sort.key];
    });
  }
}

export default angular
  .module("tttApp.adDefaultStat", [uiRouter])
  .config(routes)
  .component("adDefaultStat", {
    template: require("./adDefaultStat.html"),
    controller: AdDefaultStatComponent,
    controllerAs: "adDefaultStatCtrl",
  }).name;



// WEBPACK FOOTER //
// ./client/app/adDefaultStat/adDefaultStat.component.js